
import styles from './CardViewer.module.css'
import PresenterPageCard from './PresenterPageCard'
import PresenterProjectCard from './PresenterProjectCard'
import { getUrlEntityA } from './Url'
import { Link } from 'react-router-dom'
import { GoInfo } from "react-icons/go";
import { useLanguage } from '../contexts/LanguageContext'
import getData from './Model'

// Отображает карточку
function CardViewer(props){
    const { language } = useLanguage()
    const ui = getData('ui', language)
    
    let fragment = <>default card viewer</>
    let link_to = '_'
    let link_title = ''
    
    if (props.entity === 'pages'){
        const {page_title, page_content} = props
        link_to = 'page'
        link_title = language === 'eng' ? 'View page details' : 'Посмотреть детали страницы'
        fragment = <PresenterPageCard 
            page_title={page_title} 
            page_content={page_content} 
            language={language}
        />
    }

    if (props.entity === 'projects'){
        const {project_name, project_description} = props
        link_to = 'project'
        link_title = language === 'eng' ? 'View project details' : 'Посмотреть детали проекта'
        fragment = <PresenterProjectCard 
            project_name={project_name} 
            project_description={project_description} 
            language={language}
        />
    }

    return ( 
        <div className={styles.CardViewer}>
            {fragment}
            <div>
                <Link 
                    to={getUrlEntityA(link_to, props.ob_id)} 
                    title={link_title}
                >
                    <GoInfo /> 
                    {link_title ? <span className={styles.linkText}>{link_title}</span> : null}
                </Link>
            </div>
        </div> 
    )
}

export default CardViewer
